@if (!!control) {
  <div class="form-field form-row align-items-start">
    <label class="form-label" [for]="inputId">{{ label }}</label>
    <div class="flex flex-column gap-2 flex-1">
      <div class="flex gap-4">
        <div class="flex align-items-center">
          <p-radioButton
            [name]="name"
            value="text"
            [formControl]="control"
            [inputId]="inputId + '_text'" />
          <label [for]="inputId + '_text'" class="ml-2">
            Text
          </label>
        </div>
        <div class="flex align-items-center">
          <p-radioButton
            [name]="name"
            value="file"
            [formControl]="control"
            [inputId]="inputId + '_file'" />
          <label [for]="inputId + '_file'" class="ml-2">
            File(s)
          </label>
        </div>
      </div>
      @if (mode === 'text') {
        <ng-container *ngTemplateOutlet="textTemplate || defaultTextTemplate" />
      }
      @if (mode === 'file') {
        <ng-container *ngTemplateOutlet="fileTemplate || defaultFileTemplate" />
      }

      <ng-template #defaultTextTemplate>
        <div>Please provide a text template</div>
      </ng-template>

      <ng-template #defaultFileTemplate>
        <div>Please provide a file template</div>
      </ng-template>
    </div>
  </div>
}
